<template>
    <div class="wrapper">

        <v-tree ref='tree1' :canDeleteRoot="false" :data='treeData' :tpl="tpl" :halfcheck='true' @async-load-nodes='load' />
    </div>
</template>
<script>
import { mapState } from "vuex"
import { getDatabases, getTables } from "@/api/database/database"
export default {
    name: "LeftSide",
    data() {
        return {
            treeData: []

        }
    },
    computed: {
        ...mapState({
            connections: state => state.database.connections
        }),

    },
    watch: {
        connections() {
            this.treeData = this.connections.map(conn => ({ title: conn.name, async: true, type: 'conn' }))
        }
    },
    mounted() {
        // this.init();
    },
    methods: {
        init() {
            this.treeData = this.connections.map(conn => ({ title: conn.name, async: true }))
        },
        tpl(node,ctx){
            if(node.type!="table")
            return <span style="font-size:12px">
            {node.title}
            </span>
            else return <span draggable="true" style="font-size:12px" onDragstart={(e)=>this.transferData(e,node)}>{node.title}</span>
        },
        transferData(e,node){
            let tableObj = {tableColumnInfo:node.tableColumnInfo,tableName:node.title,databaseName:node.parent.title,connName:node.parent.parent.title}
            e.dataTransfer.setData("Text",JSON.stringify(tableObj))
        },
        async load(node) {
            
            this.$set(node, 'loading', true)
            let res = [];
            if (node.type == "conn") {
                res = await getDatabases({ connName: node.title })
                res.forEach((el) => {
                    if (!node.hasOwnProperty('children')) {
                        this.$set(node, 'children', [])
                    }
                    node.children.push({ title: el.Database, type: 'database', async: true })
                })
            }
            if (node.type == "database") {
                res = await getTables({ connName: node.parent.title, dbName: node.title })
                
               
                let tables = new Set(res.map(v=>v.table_name));
             
                tables.forEach((table) => {
                    if (!node.hasOwnProperty('children')) {
                        this.$set(node, 'children', [])
                    }
                    let tableColumnInfo = res.filter(v=>v.table_name == table)
                    node.children.push({ title: table, type:"table" ,tableColumnInfo })
                })
            }

            this.$set(node, 'loading', false)
        }
    }
}
</script>
<style scoped>
.wrapper {
  width: 100%;
  min-height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/views/DataFlowPage/components/LeftSide.vue